import { toast } from "react-toastify"
import { APIError } from "../api/ObservableFromFetch"
import FormatError from "../formatters/FormatError"

const handleAPIError = (error: Error | APIError | undefined, action?: () => void) => {
    action?.()
    error && toast.error(FormatError(error))
}
export default handleAPIError
